//import { get, post, put } from "./api";
import { get, getToken, post /*, put, upload, del, getToken */ } from "../../../api/axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

const getAllFolders = filters => get(url + "/v2/leasingfolder/list?" + filters);

const getFolders = (filters, page, pageSize) =>
  get(url + "/v2/leasingfolder/list?" + objToQueryString({ ...filters, page, pageSize }));

const loadUserPreferences = () => {
  return get(`${url}/leasingfolders/user-preferences`);
};

const updateUserPreferences = userPreferences => {
  var newUserPreferences = userPreferences.reduce((items, item) => {
    if (!item.isDefault) {
      const newItem = { filterName: item.filterName, preferenceValue: JSON.stringify(item) };
      items.push(newItem);
    }
    return items;
  }, []);

  return post(`${url}/leasingfolders/update-user-preferences`, { userPreferences: newUserPreferences });
};

const updateResponsibleOnFolders = (folderList, responsibleId, responsibleName) =>
  post(`${url}/leasingfolders/updateResponsible`, { folderList, responsibleId, responsibleName });

const exportFolders = (filters, fieldsToShow) =>
  post(`${url}/leasingfolders/exportFolders/list`, { ...filters, fieldsToShow });

const buildFolderExportDownloadUrl = (filePath, fileName) => {
  return `${url}/leasingfolders/exportsFolders/file/${encodeURIComponent(filePath)}/${encodeURIComponent(
    fileName
  )}?access_token=${getToken()}`;
};

const exp = {
  getAllFolders,
  getFolders,
  updateResponsibleOnFolders,
  loadUserPreferences,
  updateUserPreferences,
  exportFolders,
  buildFolderExportDownloadUrl
};
export default exp;
